import React from 'react'
import { Redirect, Switch } from 'react-router-dom'
import { ContentRoute } from '../../../_metronic/layout' 
import MasterUserAllDetails from './components/MasterUserAllDetails'
import SubUserOfMasterUser from './components/SubUserOfMasterUser'
import MasterUser from './MasterUser'

export default function MasterUserPage() {
    return (
        <Switch>
            <Redirect exact={true} from={ "/master-user"} to={ "/master-user/list"} />
            <ContentRoute from={ "/master-user/list"} component={MasterUser} />
            <ContentRoute from={ "/master-user/all-details"} component={MasterUserAllDetails} />
            <ContentRoute from={ "/master-user/selected-subuser"} component={SubUserOfMasterUser} />
        </Switch>
    )
}
